import { axiosInstance } from '@/utils/libs/axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

export const customOptionSchema = z.object({
  id: z.string().optional(),
  custom_field_id: z.string().optional(),
  option: z.string().optional(),
  is_enable: z.boolean()
});

export type ICustomOptionSchema = z.infer<typeof customOptionSchema>;

export const CustomOptionService = {
  useCreate: () =>
    useMutation({
      mutationFn: async (data: ICustomOptionSchema) => {
        const response = await axiosInstance.post(
          '/api/crud/custom-option',
          data,
        );
        return response.data;
      },
    }),

  useDelete: () =>
    useMutation({
      mutationFn: async (id: string) => {
        const response = await axiosInstance.delete(
          `/api/crud/custom-option/${id}`,
        );
        return response.data;
      },
    }),

  useGet: (id?: string) =>
    useQuery<ICustomOptionSchema>({
      queryKey: ['custom-option', id],
      queryFn: async () => {
        if (!id) return {};

        const response = await axiosInstance.get(
          `/api/crud/custom-option/${id}`,
        );
        return response.data?.data;
      },
    }),

  useUpdate: () =>
    useMutation({
      mutationFn: async (data: ICustomOptionSchema) => {
        const response = await axiosInstance.post(
          `/api/crud/custom-option/${data.id}`,
          data,
        );
        return response.data;
      },
    }),

  useBulkCreate: () =>
    useMutation({
      mutationFn: async (data: ICustomOptionSchema[]) => {
        const response = await axiosInstance.post(
          '/api/crud/custom-option/bulk',
          data,
        );
        return response.data;
      },
    }),

  useGetByCustomField: (customFieldId: string) =>
    useQuery<ICustomOptionSchema[]>({
      queryKey: ['custom-option', 'customFieldId', customFieldId],
      queryFn: async () => {
        const response = await axiosInstance.get(
          `/api/crud/custom-option/field/${customFieldId}`,
        );
        return response.data?.data;
      },
    }),
};
